VjsAdmin.VjsAdminUsers = (function () {
    const $table = $('#users-table');

    const init = function () {
        initTable();

        new UserEvents();
    };

    const UserEvents = VjsAdmin.Controller.extend({
        events: {
            'click .disable-2fa': 'clickDisable2fa',
            'click #export-form': 'clickExportForm',
        },
        clickDisable2fa(e) {
            const url = $(e.currentTarget).data('url');
            if (!window.confirm('Are you sure you want to disable the users 2 factor authentication?')) {
                return;
            }

            $.post(url, { _METHOD: 'DELETE' })
                .done(() => {
                    $table.bootstrapTable('refresh');
                })
                .fail(() => {
                    alert('There was an issue with removing 2 factor authentication.');
                });
        },
        clickExportForm(e) {
            e.preventDefault();
            const href = e.target;

            const visibleColumns = $table.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace(/<br>/g, ' ');
                }
            });

            const params = {};
            params.active = $('#status-filter option:selected').val();
            params.role = $('#role-filter option:selected').val();
            params.columns = exportColumns;
            params.page_size = 99999;
            window.open(`${href}?${$.param(params)}`, 'Export');
        },
    });

    const statusFilter = $('<select id="status-filter" class="form-control" style="width: 300px; margin: 0 10px;"></select>');
    statusFilter.append('<option value="true" selected>Active accounts</option>');
    statusFilter.append('<option value="false">Disabled accounts</option>');
    statusFilter.append('<option value="">All accounts</option>');

    const roleFilter = $('<select id="role-filter" class="form-control" style="width: 300px; margin: 0 10px;"></select>');
    const populateRoles = function () {
        $.get(Slim.Router.pathFor('user_management.roles.get'), (response) => {
            if (response) {
                roleFilter.append('<option value="" selected>All roles</option>');
                Object.values(response).forEach((role) => {
                    SafeDOM.appendOptionSafe(roleFilter, role, role);
                });
            }
        }).fail(() => {
            console.error('Failed to fetch roles.');
        });
    };
    populateRoles();

    const initTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#users-table',
            formatNoMatches() {
                return 'No users matching the search criteria';
            },
            onPostHeader() {
                const toolbar = $('.float-left.search.btn-group');
                toolbar.append(statusFilter);
                toolbar.append(roleFilter);
                $('.fixed-table-toolbar').prepend(toolbar);
            },
            idField: 'user_id',
            sortName: 'date_last_activity',
            sortOrder: 'desc',
            status_filter: 'true',
            role_filter: '',
            url: Slim.Router.pathFor('user_management.users.list.json'),
            columns: [
                {
                    title: 'ID',
                    field: 'user_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Username',
                    field: 'username',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Email',
                    field: 'email',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'SSO Credential',
                    field: 'sso_credential',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Google',
                    field: 'google_sub',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter: (value) => (value ? 'Linked' : '-'),
                },
                {
                    title: 'Form login',
                    field: 'form_login_allowed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter: (value) => (+value === 1 ? 'Yes' : 'No'),
                },
                {
                    title: '2FA',
                    field: 'auth2fa_enabled',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter: (value) => (+value ? 'Yes' : 'No'),
                },
                {
                    title: 'User Role(s)',
                    field: 'user_roles',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                    field: 'date_modified',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Login',
                    field: 'date_last_login',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Activity',
                    field: 'date_last_activity',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: 'Actions',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, row) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    let raw = row;
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = ['date_last_login', 'date_last_activity'];
                    raw = VjsAdmin.convertDateRow(row, dateFormat, timeagoArray);

                    raw.is_active = raw.active;

                    if (+raw.logged_in === 1) {
                        raw.username += '<br><strong>(<i class="fa-regular fa-clock" aria-hidden="true"></i> Online)</strong>';
                    }

                    if (+row.auth2fa_enabled === 1) {
                        row.auth2fa = '<i class="fa fa-check-circle"></i>';
                    }
                    row.actions = '';

                    let userEditUrl;
                    if (VjsAdmin.hasPermission('user_management.users.edit.view')) {
                        userEditUrl = Slim.Router.pathFor('user_management.users.edit.view', { user_id: row.user_id });
                        row.actions += `<a href="${userEditUrl}" data-toggle="tooltip" data-placement="top" title="Edit" class="margin-right-5"><i class="fa-solid fa-pen-to-square" aria-hidden="true"></i></a>`;
                    }
                    if (VjsAdmin.hasPermission('user_management.user.loginhistory')) {
                        userEditUrl = Slim.Router.pathFor('user_management.user.loginhistory', { user_id: row.user_id });
                        row.actions += `<a href="${userEditUrl}" data-nightwatch="singleuserloginicon" data-toggle="tooltip" data-placement="top" title="Login History" class="margin-right-5"><i class="fa fa-list-alt" aria-hidden="true"></i></a>`;
                    }

                    // delete users 2FA
                    if (VjsAdmin.hasPermission('user_management.users.edit.2fa_json') && +row.auth2fa_enabled === 1) {
                        userEditUrl = Slim.Router.pathFor('user_management.users.edit.2fa_json', { user_id: row.user_id });
                        row.actions += `<a href="javascript:void(0);" data-url="${userEditUrl}" data-toggle="tooltip" data-placement="top" title="Disable 2FA" class="margin-right-5 disable-2fa"><i class="fa fa-mobile" aria-hidden="true"></i></a>`;
                    }

                    if (+row.session_locked !== 1) {
                        if (VjsAdmin.hasPermission('user_management.users.logout')) {
                            const userLogoutUrl = Slim.Router.pathFor('user_management.users.logout', { user_id: row.user_id });
                            if (+row.logged_in === 1) {
                                row.actions += `<a href="${userLogoutUrl}" class="text-danger" data-toggle="tooltip" data-placement="top" title="Logout" class="margin-right-5"><i class="fa fa-sign-out" aria-hidden="true"></i></a>  `;
                            }
                        }
                    }

                    if (parseInt(row.active, 10) !== 0) {
                        if (VjsAdmin.hasPermission('user_management.users.disable')) {
                            const disableUrl = Slim.Router.pathFor('user_management.users.disable', {
                                user_id: row.user_id,
                            });
                            row.actions += `<a href="${disableUrl}" class="text-danger" data-toggle="tooltip" data-placement="top" title="Disable Account" class="margin-right-5"><i class="fa fa-cancel" aris-hidden="true"></i></a>`;
                        }
                    } else if (VjsAdmin.hasPermission('user_management.users.enable')) {
                        const enableUrl = Slim.Router.pathFor('user_management.users.enable', {
                            user_id: row.user_id,
                        });
                        row.actions += `<a href="${enableUrl}" data-toggle="tooltip" data-placement="top" title="Enable Account" class="margin-right-5"><i class="fa fa-check" aris-hidden="true"></i></a>`;
                    }
                });
                return formattedResult;
            },
            rowStyle(row) {
                let classes = '';

                if (+row.is_active === 0) {
                    classes += 'text-danger ';
                }
                if (+row.logged_in === 1) {
                    classes += 'text-success ';
                }

                return {
                    classes,
                };
            },
            queryParams(params) {
                const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
                myParams.active = this.status_filter;
                myParams.role = this.role_filter;
                return myParams;
            },
            onPreBody(data) {
                VjsTable.tableDefaults().onPreBody.call(this, data);

                // Status filter
                $('#status-filter').off();
                $('#status-filter').on('change', () => {
                    if ($('#status-filter option:selected').val() !== '') {
                        this.status_filter = $('#status-filter option:selected').val();
                    } else {
                        this.status_filter = null;
                    }
                    $('#users-table').bootstrapTable('refresh');
                });

                // Role filter
                $('#role-filter').off();
                $('#role-filter').on('change', () => {
                    if ($('#role-filter option:selected').val() !== '') {
                        this.role_filter = $('#role-filter option:selected').val();
                    } else {
                        this.role_filter = null;
                    }
                    $('#users-table').bootstrapTable('refresh');
                });
            },
        });
    };

    return {
        init,
    };
}());
